import { render, staticRenderFns } from "./PromptModal.vue?vue&type=template&id=1c70a630&"
import script from "./PromptModal.vue?vue&type=script&lang=js&"
export * from "./PromptModal.vue?vue&type=script&lang=js&"
import style0 from "./PromptModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports